module.exports = __webpack_public_path__ + "img/under-construction.341fc659.png";